/* NT reviews carousel 2026-09-30 – slow auto-advance (pauses on hover/touch/focus/offscreen; loops) */
(function () {
  function init() {
    document.querySelectorAll('[data-nt-rv]').forEach(function (sec) {
      if (sec.__ntrv) return; sec.__ntrv = 1;
      var ms = parseInt(sec.getAttribute('data-interval'), 10) || 0;
      var track = sec.querySelector('[data-cc-track]');
      if (!track || ms < 2000) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var paused = false, visible = false, stopUntil = 0;
      function hold() { stopUntil = Date.now() + ms * 2; }
      ['mouseenter', 'focusin', 'touchstart', 'pointerdown', 'wheel'].forEach(function (ev) {
        sec.addEventListener(ev, function () { paused = ev === 'mouseenter' || ev === 'focusin' ? true : paused; hold(); }, { passive: true });
      });
      sec.addEventListener('mouseleave', function () { paused = false; });
      sec.addEventListener('focusout', function () { paused = false; });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }, { threshold: 0.3 }).observe(sec);
      } else visible = true;
      setInterval(function () {
        if (paused || !visible || document.hidden || Date.now() < stopUntil) return;
        var max = track.scrollWidth - track.clientWidth;
        if (max < 4) return;
        var x = Math.abs(track.scrollLeft);
        var card = track.firstElementChild;
        var step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 16) : 300;
        var rtl = getComputedStyle(track).direction === 'rtl';
        if (x > max - 4) track.scrollTo({ left: 0, behavior: 'smooth' });
        else track.scrollBy({ left: (rtl ? -1 : 1) * step, behavior: 'smooth' });
      }, ms);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
